interface Options {
  search?: Maybe<string>
}

export const payerInvitationRoutes = {
  landing: '/sign-up/payers/landing',
  product: '/sign-up/payers/product',
  getStarted: '/sign-up/payers/get-started',
  businessDetails: '/sign-up/payers/business-details',
  revenue: '/sign-up/payers/revenue',
  capitalNeed: '/sign-up/payers/capital-need',
  createAccount: '/sign-up/payers/create-account',
} as const

export const getPayerSignUpPath = (route: keyof typeof payerInvitationRoutes, options?: Options) => {
  const { search } = options ?? {}
  const pathname = payerInvitationRoutes[route]

  return search ? `${pathname}?${search}` : pathname
}
